import { useRef, useEffect } from "react";
import LineChart from "./LineChart";
import { Table } from "apache-arrow";
import useWindowDimensions from "../hooks/useWindowDimensions";
import { useColorModeValue, useTheme } from "@chakra-ui/react";

type RankingType = {
  team: string;
  week: number;
  rank: number;
};

const RankHistoryChart = ({
  rankHistory,
  width,
}: {
  rankHistory: Table[];
  width: number;
}) => {
  const chartRef = useRef<HTMLDivElement>(null);
  const { height } = useWindowDimensions();

  const flattened = rankHistory
    .map((tbl, index) => {
      return tbl.toArray().map((row) => {
        return { week: index + 1, team: row["team"], rank: row["total"] };
      });
    })
    .reduce((acc, curr) => acc.concat(curr));

  const theme = useTheme();
  const lineColor = useColorModeValue(
    theme.colors.blue["600"],
    theme.colors.blue["200"]
  );

  const yMax = 60;
  const yMin = 10;

  useEffect(() => {
    if (width === 0) return;
    const chart = LineChart(flattened, {
      x: (d: RankingType) => d.week,
      y: (d: RankingType) => d.rank,
      z: (d: RankingType) => d.team,
      yLabel: "Weekly Rank",
      height: height / 3,
      width: width,
      color: lineColor,
      title: undefined,
      defined: undefined,
      xDomain: [1, Object.keys(rankHistory).length],
      yDomain: [yMin, yMax],
      yFormat: undefined,
      zDomain: undefined,
      strokeLinecap: undefined,
      strokeLinejoin: undefined,
      strokeOpacity: undefined,
      voronoi: undefined,
    });

    chartRef?.current?.append(chart);
    return () => chart.remove();
  }, [width, flattened, rankHistory, height, lineColor]);

  return <div ref={chartRef} />;
};

export default RankHistoryChart;
